/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { PureComponent } from 'react';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import {
    AddressItem,
    Title,
    Wrap,
    Info,
    Dot,
    Name,
    Description,
    DescriptionValue,
    Edit,
} from './styles';

export default class CheckoutAddressItem extends PureComponent {
    render() {
        const {
            onClick,
            address,
            noEdit,
            title,
            editLink,
            active,
            loading,
            single,
            dark,
            noSelect,
        } = this.props;

        return (
            <AddressItem loading={loading} dark={dark}>
                {!!title && (
                    <Title>
                        <Translator tk={title} />:
                    </Title>
                )}
                <Wrap onClick={onClick} active={active} noSelect={noSelect}>
                    <Info single={single} noSelect={noSelect}>
                        <Dot active={active} single={single} noSelect={noSelect} />
                        <Name dark={dark}>
                            {address.address1}{' '}
                            {!address.additional_info
                                ? address.address2
                                : `${address.address2}, ${address.additional_info}`}
                        </Name>
                        <Description>
                            <DescriptionValue dark={dark}>
                                {address.city}, {address.zipcode}
                            </DescriptionValue>
                            <DescriptionValue dark={dark}>{address.country_name}</DescriptionValue>
                        </Description>
                        {!noEdit && (
                            <Edit to={editLink} onClick={(e) => e.stopPropagation()} dark={dark}>
                                <Translator tk="EDIT_ADDRESS" />
                            </Edit>
                        )}
                    </Info>
                </Wrap>
            </AddressItem>
        );
    }
}
